import { KendoGridConfig } from '../../../../_foundation/kendo/models/grid.models';

const locationGridConfig: KendoGridConfig = {
  defaultSort: [{ field: 'name', dir: 'asc' }],
  columns:
    [
      {
        field: 'name',
        title: 'Location Name',
        filter: 'text',
        _width: 170
      },
      {
        field: 'latitudeDisplay',
        title: 'Latitude (Degrees Decimal Minutes)',
        filter: 'text',
        sortable: false,
        _width: 160
      },
      {
        field: 'longitudeDisplay',
        title: 'Longitude (Degrees Decimal Minutes)',
        filter: 'text',
        sortable: false,
        _width: 170
      },
      {
        field: 'latitudeDecimalDegrees',
        title: 'Latitude (Decimal Degrees)',
        filter: 'numeric',
        _width: 160
      },
      {
        field: 'longitudeDecimalDegrees',
        title: 'Longitude (Decimal Degrees)',
        filter: 'numeric',
        _width: 170
      },
      {
        field: 'easting',
        title: 'Easting',
        filter: 'text',
        _width: 130
      },
      {
        field: 'northing',
        title: 'Northing',
        filter: 'text',
        _width: 130
      },
      {
        field: 'coaCount',
        title: 'COAs',
        filter: 'numeric',
        _width: 80
      },
      {
        field: '_actions',
        title: 'Actions',
        filterable: false,
        sortable: false,
        _width: 80,
      },
    ]
};

export default locationGridConfig;



// WEBPACK FOOTER //
// ./src/pages/setup/project-details/project-detail-location-grid/project-detail-location-grid.config.ts